
import SceneView from '../components/SceneView.vue';
import CustomStat from '../components/shared/CustomStat.vue';
import { computed, defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { http, EthersService as eth } from '../services';
import StaminaRefillModal from '../components/StaminaRefillModal.vue';
import { Trophy as WinRateIcon, ListAltRegular as CareerIcon, Road as TotalRunsIcon, Coins as RoiIcon, Bolt as StaminaIcon, Plus as PlusIcon } from '@vicons/fa';
import { staminaCap } from '../data/global';
import breakpoints from '../utils/breakpoints';

import { RenderArgumentsDto, HoundModel } from '../../../common';

export default defineComponent({
  name: 'Hound',
  components: { SceneView, StaminaRefillModal, PlusIcon, CustomStat, WinRateIcon, CareerIcon, TotalRunsIcon, RoiIcon, StaminaIcon },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const hound = ref<HoundModel>();
    const parents = ref<HoundModel[]>([]);
    const showStaminaModal = ref(false);
    const staminaPercentage = ref<number>(100);
    const resetHound = () => {
      http.getHound(route.params.id as string).then((res: HoundModel) => {
        hound.value = new HoundModel(res);
        if (hound.value?.maleParent) {
          parents.value.push(new HoundModel(hound.value.maleParent));
          parents.value.push(new HoundModel(hound.value.femaleParent));
        }
        staminaPercentage.value = Math.round((hound.value.stamina / hound.value.staminaCap) * 100);
      });
    };
    resetHound();
    
    const winRate = computed(() => {
      if (hound.value && hound.value.totalRuns) {
        return (((hound.value.firstPlace + hound.value.secondPlace + hound.value.thirdPlace) / hound.value.totalRuns) * 100).toFixed(2);
      }
      return '0';
    });

    const openHound = (id: string) => {
      router.push({
        name: 'Hound',
        params: {
          id: id
        }
      });
    };
    
    function renderArguments(): RenderArgumentsDto {
      return new RenderArgumentsDto({
        autoRotate: true,
        noGui: true,
        noBackground: true,
        htmlBackgroundColor: '141416FF',
        lights: true,
        geneticSequence: hound.value.geneticSequence,
        extensionTraits: hound.value.extensionTraits
      });
    }

    return {
      hound,
      winRate,
      openHound,
      renderArguments,
      parents,
      showStaminaModal,
      resetHound,
      ethReactive: eth.reactive,
      staminaPercentage,
      breakpoints
    };
  }
});
